import Api, { getApi, postApi, putApi } from './Api';
import ReactSecureStorage from 'react-secure-storage';

export const getAccountList = async (count) => {
  const url = `/admin/distributor/all/page?page=${count}&size=15`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getRequestAccountList = async (email, initialOrgName, memberType) => {
  const url = `/admin/distributor/both/request/member?email=${email}&initialOrgName=${initialOrgName}&memberType=${memberType}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getSearchAccountNameList = async (value, count) => {
  const url = `/admin/distributor/getHospitalName/page/${value}?page=${count}&size=15`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getSearchAccountEmailList = async (value, count) => {
  const url = `/admin/distributor/getEmail/page/${value}?page=${count}&size=15`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const saveDistributor = async (data) => {
  const url = `/admin/distributor/register`;
  try {
    const response = await postApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getDistributorID = async (id) => {
  const url = `/admin/distributor/${id}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const emailCheck = async ({ email, hospitalId }) => {
  const url = `/admin/member/distributor-duple-email-check?email=${email}&hospitalId=${hospitalId}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.error('Error => ', e);
    throw e;
  }
};

export const updateDistributor = async (data) => {
  const url = `/admin/distributor/update`;
  try {
    const response = await putApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getDepartmentList = async () => {
  const url = `/admin/distributor/departmentList`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const distributorRequest = async (data) => {
  const url = `/admin/distributor/request`;
  try {
    const response = await postApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const hospitalRequest = async (data) => {
  const url = `/admin/distributor/dis/request`;
  try {
    const response = await postApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getRequestForm = async (encryptId) => {
  const url = `/admin/distributor/bd/request/${encryptId}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getCompanyName = async () => {
  const url = `/admin/distributor/bd/get/company`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const approveDistributor = async (data) => {
  const url = `/admin/distributor/bd/distributor/approve`;
  try {
    const response = await postApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const approveHospital = async (data) => {
  const url = `/admin/distributor/bd/hospital/approve`;
  try {
    const response = await postApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getTermsOfUse = async (path) => {
  const url = `/surgery/download-gcs-file/config-content?path=${path}`;
  try {
    // responseType: 'text'로 파일 내용을 문자열로 수신
    const response = await Api.get(url, {
      authRequired: true,
      responseType: 'text',
    });
    const data = response.data;
    if (typeof data === 'string') return data;
    return data?.data ?? data?.content ?? String(data ?? '');
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};